import { Component, OnInit } from '@angular/core';
import { Order, OrderAchPayment } from 'app/core/model/entity-model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, AuthService, GenesisUnitOfWork } from '../../core/core.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { confirm } from 'devextreme/ui/dialog';
import moment from 'moment';

@Component({
    selector: 'app-ach-dialog',
    templateUrl: './ach-dialog.component.html',
    styleUrls: ['./ach-dialog.component.scss'],
    standalone: false
})
export class AchDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    order: Order;
    ach: OrderAchPayment;

    isToastVisible = false;
    validationGroup = 'achValidationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private auth: AuthService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        console.log(this.order);
        this.ach = this.uow.orderAchPayments.createEntity() as OrderAchPayment;
        this.ach.transactionDate = new Date();
        this.ach.created = new Date();
        this.ach.createdBy = this.auth.currentUser.userName;
        this.ach.quickBooksExport = new Date();
        this.ach.quickBooksId = 'using payments'
    }

    async save() {
        const result = await this.validate();
        if (!result) return;
        this.ach.transactionNumber = moment(new Date()).format('YYYYMMDD');


        const confirmResult = await confirm(`Are you ready to apply ACH?  This will update the pricing for the Sales Order.`,`${this.appInfo.settings.company}`)
        if (!confirmResult) return;

        this.ach.orderId = this.order.id;  //moved this to here so that the display entity property doesn't change until save
        await this.uow.commit();
        this.result.next({ success: true, value: this.ach });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\r\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\r\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    amountMatchesOrder = (e) => {
        // console.log(this.order.achDiscountAmount);
        // return e.value === this.order.achDiscountAmount;
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next(false);
    }
}
